// src/components/ProdutoModal/ProdutoModal.js
import React, { useState, useEffect } from 'react';
import './ProdutoModal.css';

function ProdutoModal({ produto, onClose, onAdicionar }) {
  const [tamanhoSelecionado, setTamanhoSelecionado] = useState(produto.opcoes[0]?.tamanho || '');
  const [quantidade, setQuantidade] = useState(1);
  const [adicionaisSelecionados, setAdicionaisSelecionados] = useState([]);

  const opcaoSelecionada = produto.opcoes.find(opt => opt.tamanho === tamanhoSelecionado);
  const precoBaseAtual = opcaoSelecionada ? opcaoSelecionada.preco : 0;
  const precoAdicionaisAtual = adicionaisSelecionados.reduce((acc, ad) => acc + ad.preco, 0);
  const precoTotalDoItem = (precoBaseAtual + precoAdicionaisAtual) * quantidade;

  useEffect(() => {
    // Garante que o tamanho padrão seja selecionado ao abrir o modal
    if (produto.opcoes.length > 0 && !tamanhoSelecionado) {
      setTamanhoSelecionado(produto.opcoes[0].tamanho);
    }
    // Reseta adicionais ao mudar o produto ou tamanho
    setAdicionaisSelecionados([]);
  }, [produto, tamanhoSelecionado]); // Dependência em tamanhoSelecionado para resetar adicionais

  const handleAdicionarAoCarrinho = () => {
    if (!opcaoSelecionada) {
      alert('Por favor, selecione um tamanho para o produto.');
      return;
    }
    if (quantidade <= 0) {
      alert('A quantidade deve ser maior que zero.');
      return;
    }

    const itemParaCarrinho = {
      produtoId: produto.id,
      nome: produto.nome,
      tamanho: tamanhoSelecionado,
      precoUnitarioBase: precoBaseAtual,
      quantidade: quantidade,
      adicionaisSelecionados: adicionaisSelecionados,
      precoTotalItem: precoTotalDoItem
    };
    onAdicionar(itemParaCarrinho);
    setQuantidade(1); // Reseta quantidade
    setAdicionaisSelecionados([]); // Reseta adicionais
    // Modal é fechado pela função onAdicionar
  };

  const handleAdicionalChange = (adicional) => {
    setAdicionaisSelecionados(prev =>
      prev.some(a => a.id === adicional.id)
        ? prev.filter(a => a.id !== adicional.id)
        : [...prev, adicional]
    );
  };

  return (
    <div className="produto-modal-overlay" onClick={onClose}>
      <div className="produto-modal-content" onClick={(e) => e.stopPropagation()}> {/* Impede clique de fechar no conteúdo */}
        <button className="modal-close-btn" onClick={onClose}>X</button>
        <h3>{produto.nome}</h3>

        <div className="modal-opcoes-tamanho">
          {produto.opcoes.map(opcao => (
            <button
              key={opcao.tamanho}
              className={tamanhoSelecionado === opcao.tamanho ? 'ativo' : ''}
              onClick={() => setTamanhoSelecionado(opcao.tamanho)}
            >
              {opcao.tamanho} (R$ {opcao.preco.toFixed(2)})
            </button>
          ))}
        </div>

        {opcaoSelecionada && opcaoSelecionada.adicionaisDisponiveis && opcaoSelecionada.adicionaisDisponiveis.length > 0 && (
          <div className="modal-adicionais">
            <h4>Adicionais:</h4>
            {opcaoSelecionada.adicionaisDisponiveis.map(adicional => (
              <label key={adicional.id}>
                <input
                  type="checkbox"
                  checked={adicionaisSelecionados.some(a => a.id === adicional.id)}
                  onChange={() => handleAdicionalChange(adicional)}
                />
                {adicional.nome} (R$ {adicional.preco.toFixed(2)})
              </label>
            ))}
          </div>
        )}

        <div className="modal-controle-quantidade">
          <button onClick={() => setQuantidade(prev => Math.max(1, prev - 1))}>-</button>
          <span>{quantidade}</span>
          <button onClick={() => setQuantidade(prev => prev + 1)}>+</button>
        </div>

        <div className="modal-total-item">
            Total: <span>R$ {precoTotalDoItem.toFixed(2)}</span>
        </div>

        <button className="modal-adicionar-btn" onClick={handleAdicionarAoCarrinho}>
          Adicionar ao Pedido
        </button>
      </div>
    </div>
  );
}

export default ProdutoModal;